"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/Button/Button.tsx
var Button_exports = {};
__export(Button_exports, {
  Button: () => Button
});
module.exports = __toCommonJS(Button_exports);
var import_react3 = __toESM(require("react"));
var import_styled_components2 = __toESM(require("styled-components"));

// src/Spinner/Spinner.tsx
var import_styled_components = __toESM(require("styled-components"));
var import_react = __toESM(require("react"));

// src/theme/helpers/create-variant-selector.ts
var createVariantSelector = (key, variants) => {
  return function selector(themeKey, values) {
    return (p) => {
      const idx = variants.findIndex((v) => v === p[key]);
      const value = values[idx];
      return `${p.theme[themeKey][value]}`;
    };
  };
};

// src/Spinner/Spinner.tsx
var variantSize = createVariantSelector("size", [
  "xs",
  "sm",
  "md",
  "lg",
  "xl"
]);
var variantThickness = createVariantSelector("trainThickness", [
  "sm",
  "md",
  "lg"
]);
var variantSpeed = createVariantSelector("animationDuration", [
  "1.5s",
  "1s",
  "750ms"
]);
var variantMode = createVariantSelector("animationMode", [
  "linear",
  "ease-in-out",
  "ease-in",
  "ease-out"
]);
function Spinner(_a) {
  var _b = _a, {
    size = "md",
    trainLength = "sm",
    trainThickness = "md",
    animationDuration = "1.5s",
    animationMode = "linear"
  } = _b, props = __objRest(_b, [
    "size",
    "trainLength",
    "trainThickness",
    "animationDuration",
    "animationMode"
  ]);
  return /* @__PURE__ */ import_react.default.createElement(
    SpinnerCss,
    __spreadValues({
      size,
      trainLength,
      trainThickness,
      animationDuration,
      animationMode
    }, props)
  );
}
var SpinnerCss = import_styled_components.default.div`
  @keyframes spin {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  width: ${variantSize("sizes", [
  "spacing2",
  "spacing3",
  "spacing5",
  "spacing8",
  "spacing12"
])};
  height: ${variantSize("sizes", [
  "spacing2",
  "spacing3",
  "spacing5",
  "spacing8",
  "spacing12"
])};

  border-radius: 50%;
  border: ${variantThickness("sizes", ["spacingXs", "spacing1", "spacing2"])}
    solid ${(p) => p.railColor ? p.railColor : p.theme.colors.gray300};

  border-top-color: ${(p) => p.trainColor ? p.trainColor : p.theme.colors.gray500};
  ${(p) => (p.trainLength === "md" || p.trainLength === "lg") && `border-right-color: ${p.trainColor ? p.trainColor : p.theme.colors.gray500};`}
  ${(p) => p.trainLength === "lg" && `border-bottom-color: ${p.trainColor ? p.trainColor : p.theme.colors.gray500};`}

  animation: ${variantSpeed(
  "animationSpeeds",
  [1500, 1e3, 750]
)} spin infinite ${variantMode("animationModes", [
  "linear",
  "easeInOut",
  "easeIn",
  "easeOut"
])};

  &.multi {
    border-bottom-color: blue;
  }
`;

// src/FontIcon/FontIcon.tsx
var import_classnames = __toESM(require("classnames"));
var import_react2 = __toESM(require("react"));
function FontIcon({
  name,
  className,
  onClick,
  onError,
  externaltestid
}) {
  name = name.toLowerCase();
  return /* @__PURE__ */ import_react2.default.createElement(
    "span",
    {
      className: (0, import_classnames.default)(className, `bwicon-${name}`),
      onClick,
      "aria-hidden": "true",
      "data-externaltestid": externaltestid,
      onError
    },
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path1" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path2" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path3" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path4" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path5" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path6" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path7" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path8" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path9" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path10" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path11" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path12" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path13" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path14" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path15" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path16" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path17" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path18" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path19" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path20" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path21" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path22" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path23" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path24" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path25" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path26" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path27" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path28" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path29" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path30" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path31" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path32" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path33" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path34" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path35" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path36" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path37" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path38" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path39" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path40" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path41" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path42" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path43" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path44" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path45" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path46" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path47" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path48" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path49" }),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "path50" })
  );
}

// src/Button/Button.tsx
var Button = import_react3.default.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      variant = "primary",
      size = "normal",
      type = "button",
      rounded = false,
      loading,
      children,
      testid,
      externaltestid,
      iconName
    } = _b, props = __objRest(_b, [
      "variant",
      "size",
      "type",
      "rounded",
      "loading",
      "children",
      "testid",
      "externaltestid",
      "iconName"
    ]);
    const themeContext = (0, import_react3.useContext)(import_styled_components2.ThemeContext);
    const spinnerColor = variant === "secondary" ? themeContext.colors.black : variant === "outlined" ? themeContext.colors.submitButtonColor : themeContext.colors.white;
    return /* @__PURE__ */ import_react3.default.createElement(
      ButtonWrapperCss,
      __spreadValues({
        type,
        variant,
        size,
        rounded,
        "data-testid": testid,
        "data-externaltestid": externaltestid
      }, props),
      loading && /* @__PURE__ */ import_react3.default.createElement(ButtonSpinnerContainerCss, null, /* @__PURE__ */ import_react3.default.createElement(
        Spinner,
        {
          size: variant === "secondary" || size === "xs" ? "sm" : "md",
          trainColor: spinnerColor,
          trainThickness: "sm",
          animationDuration: "750ms",
          trainLength: "md",
          railColor: "transparent",
          animationMode: "ease-out"
        }
      )),
      /* @__PURE__ */ import_react3.default.createElement(ButtonLabelCss, { visible: !loading }, children),
      iconName && /* @__PURE__ */ import_react3.default.createElement(FontIconCss, { name: iconName })
    );
  }
);
Button.displayName = "Button";
var ButtonWrapperCss = import_styled_components2.default.button`
  position: relative;
  outline: none;
  padding: 0;
  width: 100%;
  border: 0;
  height: ${(p) => p.theme.sizes.spacing12};
  border-radius: ${(p) => p.theme.button.borderRadius};
  font-size: ${(p) => p.theme.typography.textLg};
  ${(p) => p.theme.getFontStyle("primary", "semiBold")}
  background-color: transparent;
  cursor: pointer;
  transition: all 200ms;

  &:disabled {
    opacity: ${(p) => p.theme.button.disabledOpacity};
    background-color: ${(p) => p.theme.button.disabledBgColor};
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    filter: ${(p) => p.theme.button.shadow};
  }

  ${(p) => p.variant === "primary" && primaryCss}
  ${(p) => p.variant === "secondary" && secondaryCss}
  ${(p) => p.variant === "tertiary" && tertiaryCss}
  ${(p) => p.variant === "standard" && standardCss}
  ${(p) => p.variant === "outlined" && outLinedCss}

  ${(p) => p.size === "sm" && smButtonCss}
  ${(p) => p.size === "xs" && xsButtonCss}

  ${(p) => p.rounded && roundedCss}

  ${(p) => p.type === "submit" && p.variant === "primary" ? `background-color: ${p.theme.button.submitButtonColor};` : ""}
  ${(p) => p.bg && `
    background-color: ${p.bg};
  `}
  ${({ color }) => color && `color: ${color};`}
`;
var ButtonLabelCss = import_styled_components2.default.span`
  display: inline-block;
  opacity: ${(p) => p.visible ? "1" : "0"};
  vertical-align: ${(p) => p.theme.button.verticalAlign};
`;
var primaryCss = import_styled_components2.css`
  color: ${(p) => p.theme.button.primaryLabelColor};
  background-color: ${(p) => p.theme.button.primaryBgColor};
`;
var secondaryCss = import_styled_components2.css`
  font-size: ${(p) => p.theme.typography.textXs};
  width: initial;
  border-radius: ${(p) => p.theme.button.secondaryButtonRadius};
  padding-right: ${(p) => p.theme.sizes.spacing8};
  padding-left: ${(p) => p.theme.sizes.spacing8};
  height: ${(p) => p.theme.sizes.spacing8};
  text-transform: uppercase;
  color: ${(p) => p.theme.button.secondaryLabelColor};
  background-color: ${(p) => p.theme.button.secondaryBgColor};
`;
var tertiaryCss = import_styled_components2.css`
  color: ${(p) => p.theme.button.tertiaryLabelColor};
  background-color: ${(p) => p.theme.button.tertiaryBgColor};
`;
var standardCss = import_styled_components2.css`
  color: ${(p) => p.theme.colors.white};
  background-color: ${(p) => p.theme.colors.velvet300};
`;
var outLinedCss = import_styled_components2.css`
  color: ${(p) => p.theme.button.submitButtonColor};
  border: ${(p) => `2px solid ${p.theme.button.submitButtonColor} !important`};
`;
var xsButtonCss = import_styled_components2.css`
  height: 32px;
  font-size: ${(p) => p.theme.typography.textSm};
`;
var smButtonCss = import_styled_components2.css`
  height: 40px;
  font-size: ${(p) => p.theme.typography.textSm};
`;
var roundedCss = import_styled_components2.css`
  border-radius: ${(p) => p.theme.sizes.borderRadiusFull};
`;
var ButtonSpinnerContainerCss = import_styled_components2.default.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: red;
`;
var FontIconCss = (0, import_styled_components2.default)(FontIcon)`
  position: absolute;
  right: ${(p) => p.theme.sizes.spacing4};
  top: 50%;
  transform: translateY(-50%);
`;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Button
});
